import React, { createContext, useState, useContext, ReactNode, useCallback, useMemo } from 'react';

interface ConnectionContextType {
  isOffline: boolean;
  setIsOffline: (offline: boolean) => void;
}

const ConnectionContext = createContext<ConnectionContextType | undefined>(undefined);

export const ConnectionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOffline, setIsOffline] = useState(false);

  const stableSetIsOffline = useCallback((offline: boolean) => {
    setIsOffline(prev => (prev !== offline ? offline : prev));
  }, []);

  const contextValue = useMemo(() => ({
    isOffline,
    setIsOffline: stableSetIsOffline,
  }), [isOffline, stableSetIsOffline]);

  return (
    <ConnectionContext.Provider value={contextValue}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => {
  const context = useContext(ConnectionContext);
  if (context === undefined) {
    throw new Error('useConnection must be used within a ConnectionProvider');
  }
  return context;
};

